export enum LegalPageUid {
  CitizenCGU = 'cgu-citoyen',
  ProCGU = 'cgu-pro',
  CommunityCGU = 'cgu-asso',
  CGV = 'cgv',
  LegalNotice = 'mentions-legales',
  PrivacyPolicy = 'confidentialite',
}
